import { render, staticRenderFns } from "./selfStudyArea.vue?vue&type=template&id=6d228f8d&scoped=true"
import script from "./selfStudyArea.vue?vue&type=script&lang=js"
export * from "./selfStudyArea.vue?vue&type=script&lang=js"
import style0 from "./selfStudyArea.vue?vue&type=style&index=0&id=6d228f8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d228f8d",
  null
  
)

export default component.exports